export default class PrepareFileToDownloadException extends Error {
    public constructor(message?: string) {
      super(message ?? 'Houve um problema ao preparar o arquivo para download!');
      this.name = 'PrepareFileToDownloadException';
    }
  }
